/*
Copyright© Celligence International, LLC - 2024
This software program is protected by copyright laws and is the property of
Celligence International, LLC (Celligence). Any unauthorized reproduction,
distribution, modification, or public display of this program, without the
explicit permission of Celligence is strictly prohibited. If you have gained
access to this program without the expressed approval of Celligence report
the incident to legal@celligence.com.
*/

import { Alert, Portal, Snackbar } from '@mui/material';
import Styles from '../../css/LoginPage.module.css';
import LoginModal from '../modals/LoginModal';
import LoadingModal from '../modals/LoadingModal';
import { preventDefaultAndStopPropagation } from '../../common/UtilityFunctions';
import { useLoginContext } from '../../contexts/LoginContext';
import { useState } from 'react';
import personWithCircleIcon from '../../assets/personWithCircleIcon.png';
import SWLogo from '../../assets/SWLogoWhBg.png';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { NavLink } from 'react-router-dom';
import ChooseOTPModal from '../modals/ChooseOTPModal';

const LoginForm = () => {
  const loginContext = useLoginContext();
  const [type, setType] = useState('password');
  const [icon, setIcon] = useState(<VisibilityOff />);

  const togglePass = () => {
    if (type === 'password') {
      setType('text');
      setIcon(<Visibility />);
    } else {
      setType('password');
      setIcon(<VisibilityOff />);
    }
  };

  return (
    <>
      <form className={Styles.loginPage} onSubmit={preventDefaultAndStopPropagation}>
        {loginContext.status === 'loading' && (
          <LoadingModal open={loginContext.status === 'loading'} loadingMessage={loginContext.loadingMessage} />
        )}
        {loginContext.showChooseOTPModal && <ChooseOTPModal></ChooseOTPModal>}
        {loginContext.loginModalOpen && <LoginModal />}

        <Portal>
          <Snackbar
            open={!!loginContext.statusAlert.message}
            onClose={() =>
              loginContext.setStatusAlert({
                status: '',
                message: '',
              })
            }
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            ClickAwayListenerProps={{ onClickAway: () => null }}
          >
            <Alert
              onClose={() =>
                loginContext.setStatusAlert({
                  status: '',
                  message: '',
                })
              }
              severity={loginContext.statusAlert.status as any}
              variant='filled'
              className={Styles.alert}
            >
              {loginContext.statusAlert.message}
            </Alert>
          </Snackbar>
        </Portal>

        <img className={Styles.swLogo} src={SWLogo} alt='Sunwest company logo' />
        <section className={Styles.formSection}>
          <div className={Styles.backgroundGradient}>
            <img className={Styles.personIcon} src={personWithCircleIcon} alt='Person in a circle icon' />
            <fieldset className={Styles.emailSection}>
              <label htmlFor='brwrEmail'> Email Address: *</label>
              <div>
                <input
                  className={Styles.emailLogin}
                  onChange={(e) => {
                    loginContext.setEmailAddress(e.target.value);
                  }}
                  type='text'
                  placeholder='example@gmail.com'
                  id='brwrEmail'
                />
              </div>
            </fieldset>
            <fieldset className={Styles.passwordSection}>
              <label htmlFor='brwrPassword'>Password: *</label>
              <div>
                <input
                  className={Styles.passwordLogin}
                  type={type}
                  autoComplete='off'
                  maxLength={20}
                  onChange={(e) => {
                    loginContext.setPassword(e.target.value);
                  }}
                  id='brwrPassword'
                />
                <button type='button' className={Styles.showPass} onClick={togglePass}>
                  {icon}
                </button>
              </div>
            </fieldset>
            <div className={Styles.loginDiv}>
              <button
                type='submit'
                disabled={!loginContext.emailAddress || !loginContext.password}
                onClick={loginContext.validate}
                className={
                  !loginContext.emailAddress || !loginContext.password ? Styles.loginButtonDisabled : Styles.loginButton
                }
              >
                Log In
              </button>
            </div>
            <section className={Styles.links}>
              <NavLink to='/reset-password' className={Styles.spacingLeft}>
                Forgot Password?
              </NavLink>
              <NavLink to='/create-new-account' className={Styles.spacingMiddle}>
                Create New Account
              </NavLink>
              <NavLink
                to=''
                className={Styles.spacingRight}
                onClick={(e) => {
                  e.preventDefault();
                  window.open(process.env.REACT_APP_USER_GUIDE_URL, '_blank');
                }}
              >
                Download User Guide
              </NavLink>
            </section>
          </div>
          <div className={Styles.cornerFill} />
          <div className={Styles.backgroundRightImg} />
        </section>
      </form>
    </>
  );
};

export default LoginForm;
